import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { Checkbox, FormControlLabel } from '@mui/material';

const CheckboxInput = ({input, meta, isLoading, disabled, label, dispatch, ...props}) => {
  // Исключаем пропсы redux-form, которые не должны попадать в DOM
  const { dispatch: _, meta: __, ...checkboxProps } = props;
  
  return (
    <FormControlLabel
      control={
        <Checkbox 
          checked={!!input.value}
          onChange={(event) => {
            return input.onChange(event.target.checked)
          }}
          value={input.value}
          color="primary"
          disabled={isLoading || disabled}
          {...checkboxProps}
        />
      }
      label={label}
    />
  );
}

const mapStateToProps = (state, props) => {
  const { fetch } = state;
  return {
    isLoading: !!fetch.loading
  }
}

export default compose(
  connect(mapStateToProps),
)(CheckboxInput);

